import {
  Avatar,
  Button,
  Card,
  Col,
  Descriptions,
  Flex,
  Row,
  // Skeleton,
  Typography,
} from "antd";
// import { useGetRecruiterProfile } from "api/recruiter/Profile/useGetProfile";
// import ErrorPage from "components/ui/ErrorPage";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUploadFiles } from "utils/media";

const { Title, Text } = Typography;

const RecruiterDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [logoLink, setLogoLink] = React.useState<string | null>(null);

  const { data, /*error, isPending*/ } = useGetRecruiterProfileInfo(id);

  const { getFileLink } = useUploadFiles();

  React.useEffect(() => {
    if (!data) return;
    const initialiseFormFiles = async () => {
      if (data?.companyLogo?._id) {
        const file = await getFileLink(data.companyLogo._id as string);
        // Use nullish coalescing to set null if file?.[0]?.url is undefined
        setLogoLink(file?.[0]?.url ?? null);
      }
    };

    initialiseFormFiles();
  }, [data, getFileLink]);

  // if (isPending) {
  //   return (
  //     <div className="bg-background">
  //       <div className="max-w-6xl mx-auto py-12">
  //         <Card style={{ width: "100%", marginTop: 16, height: "580px" }}>
  //           <Skeleton active />
  //           <Skeleton active />
  //           <Skeleton active />
  //           <Skeleton active />
  //         </Card>
  //       </div>
  //     </div>
  //   );
  // }

  // if (error) {
  //   return <ErrorPage error={error} />;
  // }
  // if (error) {
  //   return <ErrorPage error={error} />;
  // }

  return (
    <>
      <div className="bg-background">
        <div className="max-w-6xl mx-auto py-12">
          <Title level={2} style={{ fontWeight: 700 }}>
            Recruiter Details
          </Title>
          <Row className="mt-6" justify={"end"}>
            <Button
              type="primary"
              className="h-10 px-6  border-2 border-border text-base flex items-center gap-2 bg-primary text-white border-none"
              onClick={() => navigate(`/recruiter/profile/update/${id}`)}
            >
              Update Profile
            </Button>
          </Row>
          <Row gutter={[24, 24]} className="mt-2">
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Card className="md:py-10">
                <Flex justify="center" align="center" vertical>
                  <Avatar
                    src={
                      logoLink
                        ? logoLink
                        : "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                    }
                    size={200}
                  />
                  <Title level={4} style={{ marginBottom: 0, marginTop: "18px" }}>
                    {data?.companyName}
                  </Title>
                  <Text type="secondary">{data?.email}</Text>
                </Flex>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={16} lg={16} xl={16}>
              <Card>
                <Descriptions
                  title="Basic Information"
                  layout="vertical"
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  <Descriptions.Item label="Username">
                    {data?.userName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email">
                    {data?.email}
                  </Descriptions.Item>
                  <Descriptions.Item label="Phone Number">
                    {data?.phoneNumber}
                  </Descriptions.Item>
                  <Descriptions.Item label="Registration Number">
                    {data?.registrationNumber}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default RecruiterDetails;
 